import { ga4Push } from '../../../ga4/ga4-utilities';
import AbstractValidator from '../abstract-validator';
import AbstractValidatorOptions from '../abstract-validator-options';
import Localization from '../../../other/localization';
import { GrecaptchaV2 } from '../../../other/grecaptcha/grecaptcha-v2';
import { hideErrorMessage } from '../../../components/validator-helper';

export function initFooterNewsletterForm(device) {
    const formId = `footer-newsletter-form-${device}`;
    const deviceNameUpperCase = `${device[0].toUpperCase()}${device.slice(1)}`;
    const recaptchaElement = `footerNewsletterCaptcha${deviceNameUpperCase}`;
    const recaptchaErrorElement = $(`#footerNewsletterError${deviceNameUpperCase}`);
    const form = $(`#${formId}`);
    const validator = AbstractValidator(formId);
    const validatorOptions = AbstractValidatorOptions();
    const localization = new Localization();
    const greCaptchaV2 = new GrecaptchaV2();
    validatorOptions.scrollToFirstError = false;

    validatorOptions.focusInvalid = false;
    validatorOptions.showToastMessagesOnError = false;
    validatorOptions.onclick = (element) => {
        const elementObject = $(element);
        if (elementObject.attr('name') === 'accept_privacy_policy') {
            hideErrorMessage(elementObject);
        }
    };
    validatorOptions.errorElement = 'label';
    validatorOptions.errorPlacement = (error, element) => {
        $(element)
        .closest('.form-control-wrapper')
        .append(error);
    };
    validatorOptions.messages = {
        newsletter_firstname: {
            required: localization.getMessage(
                'validation_first_name_required',
            ),
        },
        newsletter_lastname: {
            required: localization.getMessage(
                'validation_last_name_required',
            ),
        },
        newsletter_email: {
            required: localization.getMessage(
                'validation-message-email-required',
            ),
        },
        accept_privacy_policy: {
            accept: localization.getMessage(
                'validation-message-accept-newsletter',
            ),
        },
    };
    validator.init(
        {
            newsletter_firstname: {
                maxlength: 60,
                required: true,
            },
            newsletter_lastname: {
                maxlength: 60,
                required: true,
            },
            newsletter_email: {
                required: true,
                maxlength: 60,
                customEmail: true,
            },
            accept_privacy_policy: {
                required: true,
            },
        },
        validatorOptions,
    );

    if ($(`#${recaptchaElement}`).length > 0) {
        greCaptchaV2.init(recaptchaElement);
    }

    function resetNewsletterReCaptcha() {
        greCaptchaV2.reset();
        form.find('input[type="checkbox"]')
        .removeAttr('checked')
        .prop('checked', false);
    }

    form
    .on('success', () => {
        ga4Push({
            event: 'newsletterSubscribe',
        });
        form.find('input[type="text"],input[type="email"]').val('');
        recaptchaErrorElement.empty();
        resetNewsletterReCaptcha();
    })
    .on('error', (event, errors) => {
        resetNewsletterReCaptcha();
        if (Object.keys(errors).indexOf('g-recaptcha-response') > -1) {
            recaptchaErrorElement.html(Object.values(errors)[0]);
        }
    })
    .on('invalidForm', () => {
        resetNewsletterReCaptcha();
    });
}
